module.exports = __webpack_public_path__ + "img/win-s2-icon4.cb42b1de.svg";